import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { AlertBox } from './common';

const ConfirmModal = ({ show, title, message, confirmLabel = 'Confirm', variant = 'danger', loading = false, error, onConfirm, onClose }) => (
    <Modal show={show} onHide={loading ? undefined : onClose} centered className="ss-modal" backdrop={loading ? 'static' : true}>
        <Modal.Header closeButton={!loading}>
            <Modal.Title as="h5">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {error && <AlertBox messages={error} />}
            <div>{message}</div>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="light" onClick={onClose} disabled={loading}>Cancel</Button>
            <Button variant={variant} onClick={onConfirm} disabled={loading}>
                {loading ? 'Please wait...' : error ? 'Try again' : confirmLabel}
            </Button>
        </Modal.Footer>
    </Modal>
);

export default ConfirmModal;
